<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'ExpenseConcept_Title' | translateWF: 'Expense Concepts' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit) {
            <p-button [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="openCreate()" />
          }
        </div>
      </div>
      <p class="text-sm text-[var(--p-text-muted-color)]">
        {{
          'ExpenseConcept_Subtitle'
            | translateWF: 'What an expense was spent on. Codes are assigned automatically and never change: GL account rules and receipt lines refer to them.'
        }}
      </p>
    </div>

    <div class="grid grid-cols-12 gap-[2rem]">
      <div class="col-span-12 md:col-span-3 xl:col-span-3">
        @if (filterConfig(); as config) {
          <csl-dynamic-filters [filterConfig]="config" [state]="filterState" />
        }
      </div>

      <div class="col-span-12 md:col-span-9 xl:col-span-9">
        <p-table [value]="items()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" [rowHover]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="code" style="width: 14rem">
                {{ 'ExpenseConcept_Col_Code' | translateWF: 'Code' }}
                <p-sortIcon field="code" />
              </th>
              <th>{{ 'ExpenseConcept_Col_Name' | translateWF: 'Name' }}</th>
              <th style="width: 9rem">{{ 'Status' | translateWF: 'Status' }}</th>
              @if (canEdit) {
                <th class="text-right" style="width: 6rem">{{ 'Actions' | translateWF: 'Actions' }}</th>
              }
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData>
            @let row = getRow(rowData);
            <tr>
              <!-- Edited in a modal, not a details page, so the code is plain text and the action lives in the pencil (R7). -->
              <td class="font-mono">{{ row.code }}</td>
              <td>{{ localizedName(row) }}</td>
              <td>
                <p-tag
                  [severity]="row.isActive ? 'success' : 'secondary'"
                  [value]="row.isActive ? ('ExpenseConcept_Active' | translateWF: 'Active') : ('ExpenseConcept_Inactive' | translateWF: 'Inactive')"
                />
              </td>
              @if (canEdit) {
                <td class="text-right">
                  <p-button icon="pi pi-pencil" severity="secondary" [text]="true" [rounded]="true" (click)="openEdit(row)" />
                </td>
              }
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="canEdit ? 4 : 3" class="text-center">{{ 'ExpenseConcept_Empty' | translateWF: 'No expense concepts found.' }}</td>
            </tr>
          </ng-template>
        </p-table>
        <p-paginator
          [rows]="pageSize()"
          [totalRecords]="totalRecords()"
          [first]="(currentPage() - 1) * pageSize()"
          (onPageChange)="onPageChange($event)"
          [rowsPerPageOptions]="[25, 50, 100]"
        />
      </div>
    </div>
  </div>
</main>
